import React from 'react';
import PropTypes from 'prop-types';
import { FormCardSpaced } from 'modules/common';

import { AcceptButton, UpsellVideoEmbed, EnhancedUpsell, UpsellName, UpsellAction, Widgets } from './sections';
import { WIDGETS_MAP } from 'modules/common/widgets/tools';

function CustomDonation(props) {
  return (
    <>
      <FormCardSpaced>
        <UpsellName {...props} />
        <UpsellAction {...props} />
        <AcceptButton {...props} />
      </FormCardSpaced>

      <UpsellVideoEmbed {...props} />
      <EnhancedUpsell {...props} />

      <Widgets
        {...props}
        widgetOptions={CustomDonation.widgets}
        primaryColor={props.primaryColor}
        secondaryColor={props.secondaryColor}
      />
    </>
  );
}

CustomDonation.title = 'Custom Content';
CustomDonation.description = 'Show your donors custom content.';
CustomDonation.icon = 'upsell-content';
CustomDonation.type = 'CUSTOMCONTENT';
CustomDonation.widgets = [
  WIDGETS_MAP.EXITINTENTPOPUP.value,
  WIDGETS_MAP.SHOTCLOCK.value,
  WIDGETS_MAP.COUNTDOWN.value,
  WIDGETS_MAP.COUNTDOWNTOMIDNIGHT.value,
  WIDGETS_MAP.SOCIALLINKS.value,
  WIDGETS_MAP.ACCEPTBUTTONANIMATION.value,
  WIDGETS_MAP.POLLRESULTS.value,
];

CustomDonation.propTypes = {
  editedUpsell: PropTypes.object.isRequired,
  onUpdateEditedUpsell: PropTypes.func.isRequired,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};

export default CustomDonation;
